export const _baseUrl =  'https://api.ajuda.pet' // DEV: "http://localhost:3000" //"http://ec2-3-87-193-72.compute-1.amazonaws.com:5353"
// export const _baseUrl =  'http://localhost:3002';

export const localStorageKeyToken = "doeajudapetTOKEN";
export const localStorageKeyUserId = "doeajudapetUSER_ID";

export const publishableKey = process.env.PUBLIC_KEY_HOMOG